import React from 'react';
import { Eye, Target, CheckCircle } from 'lucide-react';
export function ProductTransformation() {
  return <section className="py-20 bg-white border-y border-gray-100" data-id="element-165">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-166">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-167">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-graphite mb-6" data-id="element-168">
            IA de Alto Impacto: De la Curiosidad a la Rentabilidad
          </h2>
          <p className="text-lg md:text-xl text-gray-600" data-id="element-169">
            Un sistema práctico para responder con seguridad, guiar la
            conversación y lograr que el cliente pase de '¿precio?' a '¿cómo te
            pago?' sin persecución.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-170">
          {/* Phase 1 */}
          <div className="bg-surface rounded-2xl p-8 border border-gray-100 hover:shadow-lg transition-shadow relative overflow-hidden group" data-id="element-171">
            <div className="absolute top-0 right-0 w-24 h-24 bg-primary/5 rounded-bl-full transition-transform group-hover:scale-110" data-id="element-172"></div>
            <div className="w-14 h-14 bg-primary/10 rounded-xl flex items-center justify-center mb-6" data-id="element-173">
              <Eye className="w-7 h-7 text-primary" data-id="element-174" />
            </div>
            <div className="inline-block px-3 py-1 bg-primary/10 text-primary text-xs font-bold rounded-full mb-4" data-id="element-175">
              FASE 1: Atención
            </div>
            <h3 className="font-heading font-bold text-xl text-graphite mb-3" data-id="element-176">
              "Corta el silencio antes de que nazca."
            </h3>
            <ul className="space-y-3" data-id="element-177">
              <li className="flex items-start gap-2 text-gray-600 text-sm" data-id="element-178">
                <div className="w-1.5 h-1.5 rounded-full bg-primary mt-1.5 flex-shrink-0" data-id="element-179"></div>
                <span data-id="element-180">Aprende a responder "¿precio?" sin matar el deseo</span>
              </li>
              <li className="flex items-start gap-2 text-gray-600 text-sm" data-id="element-181">
                <div className="w-1.5 h-1.5 rounded-full bg-primary mt-1.5 flex-shrink-0" data-id="element-182"></div>
                <span data-id="element-183">
                  Mensajes cortos que mantienen a la persona dentro del chat
                </span>
              </li>
              <li className="flex items-start gap-2 text-gray-600 text-sm" data-id="element-184">
                <div className="w-1.5 h-1.5 rounded-full bg-primary mt-1.5 flex-shrink-0" data-id="element-185"></div>
                <span data-id="element-186">La IA detecta el punto exacto donde se va a enfriar</span>
              </li>
            </ul>
          </div>

          {/* Phase 2 */}
          <div className="bg-surface rounded-2xl p-8 border border-gray-100 hover:shadow-lg transition-shadow relative overflow-hidden group" data-id="element-187">
            <div className="absolute top-0 right-0 w-24 h-24 bg-accent/5 rounded-bl-full transition-transform group-hover:scale-110" data-id="element-188"></div>
            <div className="w-14 h-14 bg-accent/10 rounded-xl flex items-center justify-center mb-6" data-id="element-189">
              <Target className="w-7 h-7 text-accent" data-id="element-190" />
            </div>
            <div className="inline-block px-3 py-1 bg-accent/10 text-accent text-xs font-bold rounded-full mb-4" data-id="element-191">
              FASE 2: Relevancia
            </div>
            <h3 className="font-heading font-bold text-xl text-graphite mb-3" data-id="element-192">
              "Dejas de sonar genérica y empiezas a sonar inevitable."
            </h3>
            <ul className="space-y-3" data-id="element-193">
              <li className="flex items-start gap-2 text-gray-600 text-sm" data-id="element-194">
                <div className="w-1.5 h-1.5 rounded-full bg-accent mt-1.5 flex-shrink-0" data-id="element-195"></div>
                <span data-id="element-196">Calificas al cliente con preguntas simples</span>
              </li>
              <li className="flex items-start gap-2 text-gray-600 text-sm" data-id="element-197">
                <div className="w-1.5 h-1.5 rounded-full bg-accent mt-1.5 flex-shrink-0" data-id="element-198"></div>
                <span data-id="element-199">Personalizas sin escribir biblias</span>
              </li>
              <li className="flex items-start gap-2 text-gray-600 text-sm" data-id="element-200">
                <div className="w-1.5 h-1.5 rounded-full bg-accent mt-1.5 flex-shrink-0" data-id="element-201"></div>
                <span data-id="element-202">Conversación natural (cero presión)</span>
              </li>
            </ul>
          </div>

          {/* Phase 3 */}
          <div className="bg-surface rounded-2xl p-8 border border-gray-100 hover:shadow-lg transition-shadow relative overflow-hidden group" data-id="element-203">
            <div className="absolute top-0 right-0 w-24 h-24 bg-success/5 rounded-bl-full transition-transform group-hover:scale-110" data-id="element-204"></div>
            <div className="w-14 h-14 bg-success/10 rounded-xl flex items-center justify-center mb-6" data-id="element-205">
              <CheckCircle className="w-7 h-7 text-success" data-id="element-206" />
            </div>
            <div className="inline-block px-3 py-1 bg-success/10 text-success text-xs font-bold rounded-full mb-4" data-id="element-207">
              FASE 3: Prueba + Acción
            </div>
            <h3 className="font-heading font-bold text-xl text-graphite mb-3" data-id="element-208">
              "Conviertes la duda en pago (sin rogar)."
            </h3>
            <ul className="space-y-3" data-id="element-209">
              <li className="flex items-start gap-2 text-gray-600 text-sm" data-id="element-210">
                <div className="w-1.5 h-1.5 rounded-full bg-success mt-1.5 flex-shrink-0" data-id="element-211"></div>
                <span data-id="element-212">
                  Objeciones típicas: "está caro", "lo pienso", "después"
                </span>
              </li>
              <li className="flex items-start gap-2 text-gray-600 text-sm" data-id="element-213">
                <div className="w-1.5 h-1.5 rounded-full bg-success mt-1.5 flex-shrink-0" data-id="element-214"></div>
                <span data-id="element-215">Guiones anti-visto listos para copiar y pegar</span>
              </li>
              <li className="flex items-start gap-2 text-gray-600 text-sm" data-id="element-216">
                <div className="w-1.5 h-1.5 rounded-full bg-success mt-1.5 flex-shrink-0" data-id="element-217"></div>
                <span data-id="element-218">Cierre con instrucciones claras para pagar YA</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}